import { Redirect, useLocation, useParams } from 'react-router';
import { getLegacyEditModeUrl, parse } from '../../lib/url';
import { useIsFeatureEnabled } from '../feature-enablement/featureEnablement';
import { SplitScreen } from './SplitScreen';

// Embedded parity (embedded guard, embedded config, embeddedMiddleware.ts
// navigation swallowing, embeddedRedirectEpic post-confirm behaviour) is
// MAT-1966's scope; this route only registers `/embedded/split/:annotationId`
// symmetrically to `/embedded/document/:annotationId/edit`.
export const SplitRoute = () => {
  const isSplitEnabled = useIsFeatureEnabled('mat-1949-splitting-view');
  const location = useLocation<{ backlink?: string } | undefined>();
  const { annotationId: annotationIdParam } = useParams<{
    annotationId: string;
  }>();
  const annotationId = Number(annotationIdParam);

  if (!isSplitEnabled) {
    const legacyUrl = getLegacyEditModeUrl({
      id: annotationId,
      query: parse(location.search),
    });
    const [pathname, search] = legacyUrl.split('?');

    return (
      <Redirect
        push={false}
        to={{
          pathname,
          search: search ? `?${search}` : '',
          state: location.state,
        }}
      />
    );
  }

  return <SplitScreen annotationId={annotationId} />;
};
